import { useUpdateNodeInternals } from '@xyflow/react'
import { useEffect, useRef } from 'react'

/**
 * React Flow records handle positions only when it (re)measures a node, so a Handle that mounts
 * later on an already-measured node is unknown to connection drags (XYHandle bails on it). Force a
 * re-measure whenever the set of mounted handles changes — not on mount, which React Flow measures
 * itself. Must stay a post-commit effect: useUpdateNodeInternals looks the node element up
 * synchronously and only defers the measuring.
 */
export function useRefreshHandleBounds(nodeId: string, handleSetKey: string): void {
  const updateNodeInternals = useUpdateNodeInternals()
  const previousKey = useRef(handleSetKey)

  useEffect(() => {
    if (previousKey.current === handleSetKey) {
      return
    }
    previousKey.current = handleSetKey
    updateNodeInternals(nodeId)
  }, [nodeId, handleSetKey, updateNodeInternals])
}
